export abstract class BaseModel {
    id: number | string = 0;
}
